import * as React from "react"
import { Typography } from "@mui/material"


export default function frequencyColumn() {
	return [{
		name: "frequencyLabel", label: "Frequency",
		options: {
			display:"excluded",
			customBodyRowRender: (value) => <Typography>
				{value}
			</Typography>
		}
	},{
		name: "frequencyLabel", label: 'Frequency',
		options: {
			filter: false,
			customBodyRowRender: (value) => <Typography sx={{ textAlign: 'center'}}>
				{value}
            </Typography>
		}
	}]
}